<template>
  <div class="promotions-slider section-gradient-wrapper">
    <div class="flex items-center justify-between">
      <div class="section__title">{{ $t('promo') }}</div>
      <div class="flex items-center">
        <app-link :to="{ name: 'Promo', params: { type: 'all' } }" class="section__link">
          {{ $t('all') }}
        </app-link>
        <ol-slider-button
          class="ol-ml-lg"
          :disabled-left="progress <= 0"
          :disabled-right="progress >= 1"
          @click-left="prevSlide"
          @click-right="nextSlide"
        />
      </div>
    </div>

    <swiper v-bind="swiperOptions" @progress="onProgress" @swiper="onSwiper">
      <swiper-slide v-for="promo in promoItems" :key="promo.id">
        <the-promo-item class="swiper-slide" :promo="promo" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useStore } from 'vuex'
import ThePromoItem from 'components/promo/ThePromoItem'
import { OlSliderButton } from '@gamesite/olimp-core'
import { useQuery } from '@vue/apollo-composable'
import getContentList from 'src/apollo/queries/getContentList.gql'
import { fillPromoItems } from 'src/common/functions'

const store = useStore()

const swiperOptions = {
  preloadImages: false,
  pagination: false,
  loop: false,
  freeMode: false,
  freeModeSticky: false,
  spaceBetween: 16,
  threshold: 10,
  breakpoints: {
    1281: {
      slidesPerView: 4,
    },
    931: {
      slidesPerView: 3,
    },
    631: {
      slidesPerView: 2,
    },
  },
}

const swiperInstance = ref(null)

function onSwiper(swiper) {
  swiperInstance.value = swiper
}

const progress = ref()

const { result } = useQuery(getContentList, { type: 'promotion' })

const promoItems = computed(() => fillPromoItems(result.value?.propsContentList, store.getters.getPromoTypes))

function onProgress(instance, progressValue) {
  progress.value = progressValue
}

function nextSlide() {
  swiperInstance.value.slideNext()
}

function prevSlide() {
  swiperInstance.value.slidePrev()
}
</script>
